<button
  class="logo"
  data-testid="logo-button"
>
  <img [src]="clientTheme.logoSmallUri" alt="Rocket Close Clear Sign Logo"/>
  <div *appMobileOnly (click)="toggleDropdown()">
    <app-spark-icon icon="{{ dropDownIcon }}" size="24" ></app-spark-icon>
  </div>
</button>
